import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useUserStore } from '../store/userStore';
import { setUnauthorizedHandler } from '../services/http';
import { isJwtExpired } from '../utils/jwt';
import { appLoginPath, APP_BASE } from '../routes/appPaths';

/**
 * Следит за сессией: протухший JWT / 401 с API → logout и редирект на логин.
 */
export function SessionWatcher() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();
  const token = useUserStore((s) => s.token);
  const logout = useUserStore((s) => s.logout);
  const clearExpiredSession = useUserStore((s) => s.clearExpiredSession);

  useEffect(() => {
    clearExpiredSession();
  }, [clearExpiredSession]);

  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === 'visible') clearExpiredSession();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, [clearExpiredSession]);

  useEffect(() => {
    setUnauthorizedHandler(() => {
      logout();
      queryClient.clear();
      const path = location.pathname + location.search;
      const inApp = path === APP_BASE || path.startsWith(`${APP_BASE}/`);
      if (inApp && !path.startsWith(`${APP_BASE}/login`)) {
        navigate(appLoginPath(path), { replace: true });
      }
    });
    return () => setUnauthorizedHandler(null);
  }, [logout, queryClient, navigate, location.pathname, location.search]);

  useEffect(() => {
    if (token && isJwtExpired(token)) {
      logout();
      queryClient.clear();
    }
  }, [token, logout, queryClient]);

  return null;
}
